module.exports = __webpack_public_path__ + "media/assets/white-clock-6e3dd20018f495ef15e652e17bf1d21548ba4795c2651b2911bab4720e9d2b0d.svg";